import { render } from "./VcBlogAnalyticsFormScreen.vue?vue&type=template&id=55afc6f5"
import script from "./VcBlogAnalyticsFormScreen.vue?vue&type=script&lang=js"
export * from "./VcBlogAnalyticsFormScreen.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__